// Rileva in modo semplice il sistema operativo del dispositivo, usato per
// decidere se applicare la conferma automatica dei consensi privacy/sicurezza
// alla chiusura della scheda con il PDF (comportamento configurabile da admin).
export function detectOS() {
  const ua = (navigator.userAgent || navigator.vendor || '').toLowerCase();

  if (/android/.test(ua)) return 'android';
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  // iPadOS 13+ si presenta come desktop Safari: lo riconosciamo dal touch multiplo
  if (/macintosh/.test(ua) && navigator.maxTouchPoints > 1) return 'ios';

  return 'desktop';
}
